import React from 'react';
import { CSVLink } from 'react-csv';

interface CSVComponentProps {
  headers: any;
  csvData: any;
  label: any;
  prifix: any;
}
const Index: React.FC<CSVComponentProps> = ({
  headers,
  csvData,
  label,
  prifix,
}) => {
  const fileName =
    new Date().getFullYear() +
    '-' +
    (new Date().getMonth() + 1) +
    '-' +
    new Date().getDate() +
    ':' +
    new Date().getHours() +
    ':' +
    new Date().getMinutes() +
    ':' +
    new Date().getSeconds() +
    ':' +
    prifix +
    '.csv';

  return (
    <CSVLink
      data={csvData}
      headers={headers}
      className="btncssExp"
      filename={fileName}
    >
      {label}
    </CSVLink>
  );
};

const MemoizedComponent = React.memo(Index);
export default MemoizedComponent;
